import { Utils } from "@/plugins/utils"

export default {
    namespaced: true,
    state: {
        lstfic: [],
        fic: {
            ficcst: "",
            ficdescric: "",
            fictributa: 0,
            ficreduzbc: 0,
            ficreduzal: 0,
            fictrnscre: 0,
            ficdiferim: 0,
            ficmonofas: 0,
            ficcredzfm: 0,
            ficajuscre: 0,
        },
        insert: false,
        update: false,
        loading: false,
        itemsPerPage: 20,
        search: "",
        isLiquidation: false,
        hasNext: false,
        lastUpdatedRegister: null,
    },
    getters: {
        getUpdate(state) {
            return state.update
        },
        getfic(state) {
            let fic = { ...state.fic }
            return fic
        },
        getSearch(state) {
            return state.search
        },
        getItemsPerPage(state) {
            return state.itemsPerPage
        },
    },
    mutations: {
        set(state, fic) {
            state.fic = fic
            if (fic) state.update = true
        },
        initForm(state) {
            state.insert = false
            state.update = false
            state.fic = null
        },
        setParamsDataTable(state, payload) {
            state.lstfic = payload.items
            state.itemsPerPage = payload.limit
            state.hasNext = payload.hasNext
        },
        setLoading(state, loading) {
            state.loading = loading
        },
        setfic(state, fic) {
            state.fic = fic
        },
        setLstfic(state, lstfic) {
            state.lstfic = lstfic
        },
        setHasNext(state, hasNext) {
            state.hasNext = hasNext
        },
        setSearch(state, search) {
            state.search = search
        },
        setLastUpdatedRegister(state, lastUpdatedRegister) {
            state.lastUpdatedRegister = lastUpdatedRegister
        },
    },
    actions: {
        initForm({ commit }) {
            commit("initForm")
        },
        async search({ commit, getters, dispatch }, { limit = 20, page = 1 }) {
            commit("setLoading", true)
            commit("initForm")
            let payload = await this._vm.$axios
                .get(`/Fiscal/FiscalTaxClassification/Search?search=${getters.getSearch}&limit=${limit}&page=${page}`)
                .then(response => {
                    let payload = Utils.ValidateAxiosResponse(response.data)
                    commit("setParamsDataTable", payload)
                    return true
                })
                .catch(error => {
                    commit("setLstfic", [])
                    commit("setSearch", "")
                    dispatch(
                        "parameters/openDialog",
                        {
                            titleText: "Erro",
                            titleColor: "red",
                            text: error.message,
                        },
                        { root: true },
                    )
                    return false
                })
            commit("setLoading", false)
            return payload
        },
        async find({ commit, dispatch }, { ficcst }) {
            await this._vm.$axios
                .get(`/Fiscal/FiscalTaxClassification/Find/${ficcst}`)
                .then(response => {
                    let fic = Utils.ValidateAxiosResponse(response.data)
                    commit("set", fic)
                })
                .catch(error => {
                    dispatch(
                        "parameters/openDialog",
                        {
                            titleText: "Erro",
                            titleColor: "red",
                            text: error.message,
                        },
                        { root: true },
                    )
                })
        },		
        async save({ getters, dispatch, state }, fic) {
            if (getters.getUpdate) {
                return await dispatch("update", fic)
            }
            return await dispatch("insert", fic)
            
        },
        async insert({ commit, getters, dispatch }, fic) {
            dispatch(
                "parameters/openGlobalLoading",
                { showLoadingGlobal: true, text: "Salvando", indeterminate: true },
                { root: true },
            )
            let payload = await this._vm.$axios
                .post("/Fiscal/FiscalTaxClassification/Insert", fic)
                .then(response => {
                    let validated = Utils.ValidateAxiosResponse(response.data)
                    commit("setLastUpdatedRegister", validated)
                    commit("setfic", null)
                    return validated
                })
                .catch(error => {
                    dispatch(
                        "parameters/openDialog",
                        {
                            titleText: "Erro",
                            titleColor: "red",
                            text: error.message,
                        },
                        { root: true },
                    )
                    return false
                })
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payload
        },
        async update({ commit, getters, dispatch }, fic) {
            dispatch(
                "parameters/openGlobalLoading",
                { showLoadingGlobal: true, text: "Salvando", indeterminate: true },
                { root: true },
            )
            let payload = await this._vm.$axios
                .put("/Fiscal/FiscalTaxClassification/Update", fic)
                .then(response => {
                    commit("setLastUpdatedRegister", Utils.ValidateAxiosResponse(response.data))
                    return true
                })
                .catch(error => {
                    dispatch(
                        "parameters/openDialog",
                        {
                            titleText: "Erro",
                            titleColor: "red",
                            text: error.message,
                        },
                        { root: true },
                    )
                    return false
                })
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payload
        },
        async delete({ getters, dispatch }, ficcst) {
            dispatch(
                "parameters/openGlobalLoading",
                { showLoadingGlobal: true, text: "Excluindo", indeterminate: true },
                { root: true },
            )
            await this._vm.$axios
                .delete(`/Fiscal/FiscalTaxClassification/Delete/${ficcst}`)
                .then(response => {
                    Utils.ValidateAxiosResponse(response.data)
                    return true
                })
                .catch(error => {
                    dispatch(
                        "parameters/openDialog",
                        {
                            titleText: "Erro",
                            titleColor: "red",
                            text: error.message,
                        },
                        { root: true },
                    )
                    return false
                })
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
        },
    },
}
